import { useMediaQuery } from "@mui/system";
import { useTheme } from "@mui/joy/styles";

/**
 * True when the viewport is wide enough for the table layout (Joy's `lg`, 1200px).
 *
 * The BKG result views offer a desktop table and a mobile card list. They used to
 * render BOTH and hide one with `display: { xs: 'none', lg: 'block' }`, which
 * means a 50-row page built 50 table rows AND 50 cards -- double the DOM, double
 * the tooltip anchors, double the reconciliation on every state change, with half
 * of it invisible. Measured at 25 rows: 25 table rows and 25 cards, always.
 *
 * Choosing in JS instead lets only the live layout mount. The trade-off is that
 * the switch now happens on a media-query change rather than in pure CSS, so the
 * two layouts swap at the breakpoint rather than cross-fading -- which is what a
 * display rule did anyway.
 */
export const useWideLayout = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up("lg"));
};

export default useWideLayout;
